import React from 'react';
import CashFlowReportComponent from '../../../Components/Report/CashFlowReport';

export default function CashFlowReport() {
    return (
        <div className='page-body'>
            <CashFlowReportComponent />
        </div>
    );
}